var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSecurity = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.8397 12.0239C20.8397 16.8307 14.9567 20.3137 12.911 21.3796C12.6898 21.495 12.5792 21.5526 12.4257 21.5824C12.3061 21.6057 12.1337 21.6057 12.0141 21.5824C11.8607 21.5526 11.75 21.495 11.5288 21.3796C9.4831 20.3137 3.6001 16.8307 3.6001 12.0239V7.94846C3.6001 7.08704 3.6001 6.6563 3.74099 6.28604C3.86545 5.95895 4.0677 5.66711 4.33026 5.43572C4.62747 5.1738 5.03077 5.02256 5.83737 4.72008L11.6146 2.55363C11.8386 2.46963 11.9505 2.42763 12.0659 2.41097C12.168 2.39621 12.2718 2.39621 12.374 2.41097C12.4893 2.42763 12.6012 2.46963 12.8252 2.55363L18.6024 4.72008C19.4091 5.02256 19.8123 5.1738 20.1095 5.43572C20.3721 5.66711 20.5743 5.95895 20.6988 6.28604C20.8397 6.6563 20.8397 7.08704 20.8397 7.94846V12.0239Z",
  stroke: "#FF8B22",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5069 9.29291C15.8974 9.68339 15.8974 10.3166 15.5069 10.7071L11.5069 14.7071C11.3193 14.8946 11.065 15 10.7998 15C10.5346 15 10.2802 14.8946 10.0927 14.7071L8.09271 12.7071C7.70217 12.3165 7.70217 11.6834 8.09271 11.2929C8.48319 10.9023 9.11637 10.9023 9.50691 11.2929L10.7998 12.5858L14.0926 9.29291C14.4832 8.90236 15.1164 8.90236 15.5069 9.29291Z",
  fill: "#FF8B22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSecurity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/security.12e37d35d56ece35d0677d4ab22a6644.svg";